import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GamingService {
  public rewardResponse:any;
  static singleInstance: any;
  public isInAppViewOpen:boolean = false;
  public storageWon;
  public expiryDate;
  constructor() { 
  }
  isInAppMobileView(){
    var webViewOpened;
    // let userAgent = window.navigator.userAgent.toLowerCase();
    // let safari = /safari/.test(userAgent);
    // let ios = /iphone|ipod|ipad/.test(userAgent);
    // if (ios) {
    //     webViewOpened = (!("standalone" in window.navigator) && safari) ? false : ((!("standalone" in window.navigator) && !safari) ? true : false);
    // } else {
    //     webViewOpened = (userAgent.includes('wv')) ? true : false;
    // };
    // return webViewOpened;
    var userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent );

    if( ios ) {
        if ( safari ) {
          webViewOpened= false
        } else if ( !safari ) {
          webViewOpened = true;
        };
    } else {
      webViewOpened = (userAgent.includes('wv')) ? true : false;
    }
    return webViewOpened;
  }
}
